import BrightcoveVideo from "@atoms/players/BrightcoveVideo";
import { VideoCardProps } from "@routes/Videos/VideosPage/utils/types";

type FeaturedActiveVideoCardProps = {
  /** The video to be displayed */
  video: VideoCardProps;
};

/**
 * This is the component for displaying the featured active video card.
 */
const FeaturedActiveVideoCard = ({ video }: FeaturedActiveVideoCardProps) => {
  const { id, title, description } = video;

  return (
    <div data-testid="featured-active-video-card-component">
      <BrightcoveVideo key={id} videoId={id} className="w-full" />

      <div className="mt-4 text-gray-850">
        <h2 className="font-lct text-base font-bold">{title}</h2>

        <p className="mt-2 font-public-sans text-xs">{description}</p>
      </div>
    </div>
  );
};

export default FeaturedActiveVideoCard;
